import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var SearchIcon = function (_a) {
    var _b = _a.ariaLabel, ariaLabel = _b === void 0 ? "Search Icon" : _b, props = __rest(_a, ["ariaLabel"]);
    return (React.createElement(SvgIcon, __assign({}, props, { ariaLabel: ariaLabel }),
        React.createElement("path", { d: "M12.8 11.743h-.557l-.197-.19a4.576 4.576 0 001.042-3.759c-.331-1.956-1.964-3.519-3.935-3.758a4.579 4.579 0 00-5.117 5.117c.239 1.97 1.802 3.604 3.758 3.935a4.576 4.576 0 003.76-1.042l.19.197v.556l2.99 2.992a.743.743 0 001.05 0 .744.744 0 000-1.05l-2.985-2.998zm-4.224 0a3.163 3.163 0 01-3.168-3.167 3.163 3.163 0 013.168-3.168 3.163 3.163 0 013.167 3.168 3.163 3.163 0 01-3.167 3.167z" })));
};

export { SearchIcon };
//# sourceMappingURL=SearchIcon.esm.js.map
